import React from 'react';
import { Navigate } from 'react-router-dom';
import { Loader2 } from 'lucide-react';
import usePatientCapabilities from '../hooks/usePatientCapabilities';

/** Redirect non–faculty/staff away from referral / family routes. */
export default function FacultyStaffGate({ children }) {
  const { loading, isFacultyStaff } = usePatientCapabilities();
  if (loading) {
    return (
      <div className="flex h-screen items-center justify-center bg-[#E8EEF5]">
        <Loader2 className="h-8 w-8 animate-spin text-[#F15A22]" />
      </div>
    );
  }
  if (!isFacultyStaff) return <Navigate to="/patient" replace />;
  return children;
}
